module.exports = __webpack_public_path__ + "img/sad-cloud.f63c2f74.svg";